/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './logout.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '@angular/common';
import * as i4 from '../../../../../ClientApp/app/pages/logout/logout.component';
import * as i5 from '../../../../../ClientApp/app/_shared/services/msal.service';
import * as i6 from '../../../../../ClientApp/app/_shared/services/monitoring.service';
const styles_LogoutComponent:any[] = [i0.styles];
export const RenderType_LogoutComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_LogoutComponent,data:{}});
export function View_LogoutComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted((null as any),['Uitgelogd\n\nKlik '])),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),3,'a',([] as any[]),[[1,'target',0],[8,
          'href',4]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,2).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i2.RouterLinkWithHref,
      [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
      (null as any)),i1.ɵpad(1),(_l()(),i1.ɵted((null as any),['hier'])),(_l()(),i1.ɵted((null as any),
      [' om weer in te loggen.']))],(_ck,_v) => {
    const currVal_2:any = _ck(_v,3,0,'/login');
    _ck(_v,2,0,currVal_2);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2).target;
    const currVal_1:any = i1.ɵnov(_v,2).href;
    _ck(_v,1,0,currVal_0,currVal_1);
  });
}
export function View_LogoutComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-logout',([] as any[]),
      (null as any),(null as any),(null as any),View_LogoutComponent_0,RenderType_LogoutComponent)),
      i1.ɵdid(114688,(null as any),0,i4.LogoutComponent,[i5.MsalService,i6.MonitoringService],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const LogoutComponentNgFactory:i1.ComponentFactory<i4.LogoutComponent> = i1.ɵccf('app-logout',
    i4.LogoutComponent,View_LogoutComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9DbGllbnRBcHAvYXBwL3BhZ2VzL2xvZ291dC9sb2dvdXQuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2FwcC9DbGllbnRBcHAvYXBwL3BhZ2VzL2xvZ291dC9sb2dvdXQuY29tcG9uZW50LnRzIiwibmc6Ly8vYXBwL0NsaWVudEFwcC9hcHAvcGFnZXMvbG9nb3V0L2xvZ291dC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2FwcC9DbGllbnRBcHAvYXBwL3BhZ2VzL2xvZ291dC9sb2dvdXQuY29tcG9uZW50LnRzLkxvZ291dENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlVpdGdlbG9nZFxuXG5LbGlrIDxhIFtyb3V0ZXJMaW5rXT1cIlsnL2xvZ2luJ11cIj5oaWVyPC9hPiBvbSB3ZWVyIGluIHRlIGxvZ2dlbi4iLCI8YXBwLWxvZ291dD48L2FwcC1sb2dvdXQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQSx1REFFSzthQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7Y0FBQTtVQUFBO1FBQUE7UUFBQTtNQUFBLHVDQUFBO01BQUE7TUFBQSxzQkFBRyxJQUEwQix5Q0FBUTtNQUFBO0lBQWxDO0lBQUgsV0FBRyxTQUFIOztJQUFBO0lBQUE7SUFBQSxXQUFBLG1CQUFBOzs7O29CQ0ZMO01BQUE7YUFBQTtVQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/ClientApp/app/pages/logout/logout.component.ngfactory.ts